import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalBase from "../ModalBase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/pro-regular-svg-icons";
import { ModalInfoList, ModalInfoRow } from "./ModalInfoList";

const AvailabilityModal = ({
	isOpen,
	setIsOpen,
	onSubmit,
	connectorName,
	chargerName,
	siteName,
}) => {
	const { t } = useTranslation();
	const [selectedOption, setSelectedOption] = useState("Operative");

	const handleSubmit = () => {
		onSubmit(selectedOption);
		setIsOpen(false);
	};

	return (
		<ModalBase isOpen={isOpen} onClose={() => setIsOpen(false)} size="sm">
			<div className="flex items-center justify-between mb-4">
				<h2 className="text-lg font-bold text-sky-600 flex items-center gap-2">
					<FontAwesomeIcon icon={faGear} className="text-sky-500 text-base" />
					{t("chargeMonitor.changeAvailability")}
				</h2>
			</div>

			<p className="text-sm text-mute-700 mb-4">
				{t("chargeMonitor.selectAvailability")}
			</p>

			<ModalInfoList className="border-t border-mute-100 pt-3 mb-4">
				<ModalInfoRow label={t("entity.site")}>{siteName || "–"}</ModalInfoRow>
				<ModalInfoRow label={t("entity.charger")}>{chargerName || "–"}</ModalInfoRow>
				<ModalInfoRow label={t("entity.connector")}>{connectorName || "–"}</ModalInfoRow>
			</ModalInfoList>

			<div className="flex flex-col gap-2 mb-6">
				{[
					{ label: t("chargeMonitor.operative"), value: "Operative" },
					{ label: t("chargeMonitor.inoperative"), value: "Inoperative" },
				].map(({ label, value }) => (
					<label
						key={value}
						className={`flex items-center gap-2 px-3 py-2 border rounded-lg cursor-pointer transition 
							${selectedOption === value
								? "border-sky-400 bg-sky-50 text-sky-700 font-medium"
								: "border-mute-200 hover:bg-mute-50 text-mute-700"}`}
					>
						<input
							type="radio"
							name="availability"
							value={value}
							checked={selectedOption === value}
							onChange={(e) => setSelectedOption(e.target.value)}
						/>
						{label}
					</label>
				))}
			</div>

			<div className="flex justify-end gap-3">
				<button
					className="btn btn-outline-primary"
					onClick={() => setIsOpen(false)}
				>
					{t("common.cancel")}
				</button>
				<button
					className="btn-primary btn"
					onClick={handleSubmit}
				>
					{t("common.send")}
				</button>
			</div>
		</ModalBase>
	);
};

export default AvailabilityModal;
